export function range(size, startAt = 0) {
    return [...Array(size).keys()].map((i) => i + startAt);
}
//# sourceMappingURL=range.js.map